<template>
    <section class="tables new-updated-design">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Awards</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                    <input class="form-control" type="text" name="search" id="search" placeholder="Search"
                                        v-model="serverParams.customFilters.name" @keyup="loadItems()">
                                </div>
                                <div class="col-md-3">
                                </div>
                            </div>
                        </div>
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            :totalRows="totalRecords" :isLoading.sync="isLoading"
                            :pagination-options="{ enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], }"
                            :rows="rows" :columns="columns" :sort-options="{
                                enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap">

                                    <b-button size="sm" @click="editAwards(props.row)" class="mr-1 btn-info text-white">
                                        Edit
                                    </b-button>
                                    <b-button size="sm" @click="deleteAwards(props.row.AwardID)"
                                        class="mr-1 btn-danger text-white">
                                        Delete
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import { validationMixin } from "vuelidate";
import moment from 'moment'

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'VendorName',
    mixins: [validationMixin],
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            serverParams: {
                customFilters: {
                    name: ''
                },
                sort: [
                    {
                        field: 'AwardID', // example: 'name'
                        type: 'asc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [

                {
                    label: 'ID',
                    field: 'AwardID',
                    filterable: false,
                },
                {
                    label: 'First Name',
                    field: 'AwardFirstName',
                    filterable: false,
                },
                {
                    label: 'Last Name',
                    field: 'AwardLastName',
                    sortable: false,
                },
                {
                    label: 'Status',
                    field: "Status",
                    sortable: false,
                },
                {
                    label: 'Year',
                    field: "Year",
                    sortable: false,
                },
                {
                    label: 'Action',
                    field: "action",
                    sortable: false,
                },


            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: []
        };
    },
    methods: {
        loadItems() {
            
           
            this.isLoading = true;
            API.getAllAwards(this.serverParams,
                data => { 
                        this.totalRecords = data.data.total;
                        this.rows = data.data.data;
                        this.rows.forEach((row) => {
                            row.Year = moment(row.Year).format('Y');
                        
                        });
                        this.isLoading = false;
                    }, 
                err => {
                    this.isLoading = false;
                })
        },
        editAwards(member) {
            this.$router.push({ name: 'edit_Awards', params: { id: member.AwardID, user: member } });
        },
        deleteAwards(id) {
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    let data = {
                        id: id
                    }
                    API.deleteAward(
                        data,
                        data => {
                            this.loadItems();
                            this.$swal(
                                'Deleted!',
                                'Record has been deleted.',
                                'success'
                            )
                        },
                        err => {
                        })
                }
            })
            // this.$router.push({name: 'edit_Vendor', params: {user: member}});
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
    }
}
</script>